// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-drawer {
  z-index: 1300;
}
.notification-drawer .MuiDrawer-paper {
  width: 420px;
  max-width: 100vw;
  display: flex;
  flex-direction: column;
}

.notification-drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 12px;
  border-bottom: 1px solid #e8e8e8;
  gap: 12px;
}

.notification-drawer-title-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.notification-drawer-title {
  font-size: 18px;
  font-weight: 700;
  margin: 0;
  white-space: nowrap;
}

.notification-drawer-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.notification-drawer-mark-all {
  color: #5b4bb7;
  font-size: 12px;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
}
.notification-drawer-mark-all:hover {
  text-decoration: underline;
}

.notification-drawer-filter {
  min-width: 120px;
}
.notification-drawer-filter .MuiInputBase-root {
  font-size: 12px;
}

.notification-drawer-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 12px;
}

.notification-drawer-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.notification-card {
  position: relative;
  display: flex;
  gap: 12px;
  padding: 14px 14px 14px 16px;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}
.notification-card::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #5c6bc0;
  background: var(--notification-accent, #5c6bc0);
}

.notification-card-meta {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  z-index: 1;
}

.notification-card-checkbox {
  opacity: 0;
  transition: opacity 0.15s ease;
  height: 24px;
}

.notification-card:hover .notification-card-checkbox {
  opacity: 1;
}

.notification-card-icon {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  background: #5c6bc0;
  background: var(--notification-accent, #5c6bc0);
}

.notification-card-content {
  flex: 1 1;
  min-width: 0;
  padding-right: 24px;
}

.notification-card-title {
  font-size: 14px;
  font-weight: 700;
  margin: 0 0 6px;
  color: #222;
}

.notification-card-description {
  font-size: 13px;
  line-height: 1.45;
  color: #555;
  margin: 0;
  word-break: break-word;
}

.notification-card-date {
  font-size: 11px;
  color: #888;
  white-space: nowrap;
}

.notification-drawer-empty {
  text-align: center;
  color: #999;
  padding: 40px 16px;
}

.notification-drawer-footer {
  padding: 12px 16px 16px;
  border-top: 1px solid #e8e8e8;
  display: flex;
  justify-content: center;
}

.notification-drawer-load-more {
  min-width: 140px;
}

@media (max-width: 599px) {
  .notification-drawer .MuiDrawer-paper {
    width: 100vw;
  }
  .notification-drawer-mark-all {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Layout/Header/NotificationDrawer.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,gCAAA;EACA,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;AAAF;AAEE;EACE,0BAAA;AAAJ;;AAIA;EACE,gBAAA;AADF;AAGE;EACE,eAAA;AADJ;;AAKA;EACE,SAAA;EACA,gBAAA;EACA,aAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAFF;;AAKA;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,4BAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AAFF;AAIE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EAAA,+CAAA;AAFJ;;AAOA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;EACA,UAAA;AAJF;;AAOA;EACE,UAAA;EACA,8BAAA;EACA,YAAA;AAJF;;AAOA;EACE,UAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,mBAAA;EAAA,+CAAA;AAJF;;AAOA;EACE,SAAA;EACA,YAAA;EACA,mBAAA;AAJF;;AAOA;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AAJF;;AAOA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,SAAA;EACA,sBAAA;AAJF;;AAOA;EACE,eAAA;EACA,WAAA;EACA,mBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,WAAA;EACA,kBAAA;AAJF;;AAOA;EACE,uBAAA;EACA,6BAAA;EACA,aAAA;EACA,uBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EAEI;IACE,YAAA;EALJ;EASA;IACE,aAAA;EAPF;AACF","sourcesContent":[".notification-drawer {\n  z-index: 1300;\n\n  .MuiDrawer-paper {\n    width: 420px;\n    max-width: 100vw;\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.notification-drawer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 16px 12px;\n  border-bottom: 1px solid #e8e8e8;\n  gap: 12px;\n}\n\n.notification-drawer-title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.notification-drawer-title {\n  font-size: 18px;\n  font-weight: 700;\n  margin: 0;\n  white-space: nowrap;\n}\n\n.notification-drawer-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n}\n\n.notification-drawer-mark-all {\n  color: #5b4bb7;\n  font-size: 12px;\n  cursor: pointer;\n  text-decoration: none;\n  white-space: nowrap;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\n.notification-drawer-filter {\n  min-width: 120px;\n\n  .MuiInputBase-root {\n    font-size: 12px;\n  }\n}\n\n.notification-drawer-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px;\n}\n\n.notification-drawer-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.notification-card {\n  position: relative;\n  display: flex;\n  gap: 12px;\n  padding: 14px 14px 14px 16px;\n  border: 1px solid #e6e6e6;\n  border-radius: 10px;\n  background: #fff;\n  overflow: hidden;\n\n  &::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 4px;\n    background: var(--notification-accent, #5c6bc0);\n  }\n\n}\n\n.notification-card-meta {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  z-index: 1;\n}\n\n.notification-card-checkbox {\n  opacity: 0;\n  transition: opacity 0.15s ease;\n  height: 24px;\n}\n\n.notification-card:hover .notification-card-checkbox {\n  opacity: 1;\n}\n\n.notification-card-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #fff;\n  background: var(--notification-accent, #5c6bc0);\n}\n\n.notification-card-content {\n  flex: 1;\n  min-width: 0;\n  padding-right: 24px;\n}\n\n.notification-card-title {\n  font-size: 14px;\n  font-weight: 700;\n  margin: 0 0 6px;\n  color: #222;\n}\n\n.notification-card-description {\n  font-size: 13px;\n  line-height: 1.45;\n  color: #555;\n  margin: 0;\n  word-break: break-word;\n}\n\n.notification-card-date {\n  font-size: 11px;\n  color: #888;\n  white-space: nowrap;\n}\n\n.notification-drawer-empty {\n  text-align: center;\n  color: #999;\n  padding: 40px 16px;\n}\n\n.notification-drawer-footer {\n  padding: 12px 16px 16px;\n  border-top: 1px solid #e8e8e8;\n  display: flex;\n  justify-content: center;\n}\n\n.notification-drawer-load-more {\n  min-width: 140px;\n}\n\n@media (max-width: 599px) {\n  .notification-drawer {\n    .MuiDrawer-paper {\n      width: 100vw;\n    }\n  }\n\n  .notification-drawer-mark-all {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
